import { AlarmHistoryExperience } from "../types/Alarm";
import { Property } from "../types/Property";
import { PropertyInfo } from "../types/PropertyInfo";

export default function formatAddress(propDetails: Property | PropertyInfo) {
  return [propDetails.address1, propDetails.address2, propDetails.addressCity].filter((r) => r).join(", ");
}
